import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=4c1afa9f&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=4c1afa9f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1afa9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1afa9f')) {
      api.createRecord('4c1afa9f', component.options)
    } else {
      api.reload('4c1afa9f', component.options)
    }
    module.hot.accept("./UserPicker.vue?vue&type=template&id=4c1afa9f&scoped=true", function () {
      api.rerender('4c1afa9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/UserPicker.vue"
export default component.exports